import { algoliasearch } from 'algoliasearch';
import { Configure, InstantSearch, useHits } from 'react-instantsearch';
import css from './ListingCardSection.module.css';
import Slider from 'react-slick';
import { LISTING_STATE_PUBLISHED } from '../../constants';
import { useSelector } from 'react-redux';
import { currentUserIdSelector } from '../../ducks/user.duck';
import { useParams } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { useHistory } from 'react-router-dom';
import { createSlug } from '../../util/urlHelpers';
import { replaceHyphensWithSpace } from '../../util/data';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, useIntl } from '../../util/reactIntl';
import { CORRDINATES } from '../../containers/PageBuilder/SectionBuilder/SectionMap/SectionMap';
import ReviewRating from '../ReviewRating/ReviewRating';
const appId = process.env.REACT_APP_ALGOLIA_APP_ID;
const apiKey = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;
const listingIndex = `trending_${process.env.REACT_APP_ALGOLIA_LISTINGS_INDEX}`;
const client = algoliasearch(appId, apiKey);

function Hit({ hit, queryID }) {
  const { title, description, price, publicData, objectID, image ,averageRating } = hit || {};
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const onOverListingLink = () => {
    // Enforce preloading of ListingPage (loadable component)
    const { component: Page } = findRouteByRouteName('ListingPage', routeConfiguration);
    // Loadable Component has a "preload" function.
    if (Page.preload) {
      console.log('loading..');
      Page.preload();
    }
  };

  const onClickListingLink = () => {
    history.push(
      createResourceLocatorString(
        'ListingPage',
        routeConfiguration,
        { id: objectID, slug: createSlug(title) },
        { queryID }
      )
    );
  };

  return (
    <div
      onMouseOver={onOverListingLink}
      onTouchStart={onOverListingLink}
      onClick={onClickListingLink}
      className={css.card}
    >
      <div className={css.imageContainer}>
        <img className={css.cardImage} src={hit.image} alt={hit.name} />
      </div>
      <div className={css.cardBody}>
        <h3 className={css.cardTitle}>{hit.title}</h3>
        <p className={css.cardDesc}>{hit.description}</p>
        <p className={css.cardPrice}>
          <b>${hit.price}</b>
          <span className={css.averageRating}>
            {averageRating > 0 ?
              <ReviewRating
                rating={hit.averageRating}
                className={css.mobileReviewRating}
                reviewStarClassName={css.reviewRatingStar}
                isSearchPage={true}
              />
              : <span className={css.noReviews}>
                  {intl.formatMessage({ id: 'ListingHit.noReviews' })}
              </span>
              }
          </span>
        </p>
      </div>
    </div>
  );
}

var settings = {
  dots: false,
  infinite: false,
  speed: 1500,
  slidesToShow: 4.6,
  slidesToScroll: 3,
  arrows: true,
  swipe: true,
  swipeToSlide: true,
  draggable: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3.6,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2.6,
        slidesToScroll: 2,
        arrows: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

const CustomHits = ({currentUser}) => {
  const { items: hits, results } = useHits();
  const queryID = results && results.queryID;

  if (!hits || hits.length === 0) return null;

  return (
    <div className={css.sliderWrapper}>
      {hits && currentUser ? (
        <Slider {...settings}>
          {hits.map(hit => (
            <Hit key={hit.objectID} hit={hit} queryID={queryID} />
          ))}
        </Slider>
      ) : null}
    </div>
  );
};

const UserNotLogin = ({ currentUser }) => {
  return (
    <div className={css.signUpMessage}>
      {!currentUser ? (
        <p>
          {<FormattedMessage id='ListingCardSection.signUpMessage' />}
        </p>) : null}
    </div>)
}

const ListingCardSection = ({ country ,currentUser}) => {
  const { country: paramsCountry = null, region: paramsRegion = null, pageId } = useParams() || {};
  const currentUserId = useSelector(currentUserIdSelector);
  const isCountryLandingPage = !!paramsCountry;
  const isRegionLandingPage = !!paramsRegion;

  // const countryFilter = isCountryLandingPage
  //   ? ` AND publicData.destinationCountries:'${replaceHyphensWithSpace(paramsCountry)}'`
  //   : isRegionLandingPage
  //   ? ` AND publicData.destinationRegions:'${country || paramsRegion}'`
  //   : '';

    const countryFilter = pageId && CORRDINATES[pageId] && CORRDINATES[pageId].isRegion
    ? ` AND publicData.destinationRegions:'${CORRDINATES[pageId].name}'`
    : pageId && CORRDINATES[pageId] ? ` AND publicData.destinationCountries.name:'${CORRDINATES[pageId].name}'`
    : '';

    const filters = `state:'${LISTING_STATE_PUBLISHED}'${countryFilter}`;

  return (
    <>
      <InstantSearch
        key={`${listingIndex}-${country}`} // Forces re-initialization on indexName change
        searchClient={client}
        indexName={listingIndex}
        initialUiState={{
          [listingIndex]: {
            configure: {
              filters,
            },
          },
        }}
        insights={true}
      >
        <Configure hitsPerPage={10} clickAnalytics={true} userToken={currentUserId} />
        <CustomHits currentUser={currentUser}/>
        <UserNotLogin currentUser={currentUser}/>
      </InstantSearch>
    </>
  );
};
const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};


export default compose(
  connect(
    mapStateToProps
  ),
  injectIntl
)(ListingCardSection);
